module.exports = {

	BASE_URL: 'https://stjosephschool.kalvisalai.in/admin/',

	ACC_URL: 'https://stjosephschool.kalvisalai.in/accounts/',

	APP_NAME: 'School Management',
	Scl_NAME: 'STJOSEPH ENGLISH HIGH SCHOOL',
	Sclful_NAME: 'STJOSEPH ENGLISH HIGH SCHOOL',
	Scl_Addr: 'Thavalakuppam ',
	Scl_Dist: 'Puducherry DISTRICT – 607 402'
	

};


// WEBPACK FOOTER //
// ./src/Globals.js